import { Button, Nav } from "react-bootstrap";
import logo from "../../assets/hourglass-logo-brown.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useContext } from "react";
import HourglassGlobals, { HGContext } from "../../helpers/globals";
import { Permission } from "../../types/permission";
import { NavLoggedInUser } from "./loggedInUser";
import { SMPWDropdown } from "./smpw";
import { HaveSMPWInvite } from "../smpw/invite";

export function HourglassUserNav() {
  const { t } = useTranslation();
  const ctx = useContext(HGContext);

  const hasAttendance = ctx.globals.permissions.has(Permission.UpdateAttendance);
  const showSmpwMenu = !!ctx.globals.smpwRootZone?.id;

  return (
    <>
      <Nav className="top-nav d-flex p-0">
        <Link className="" to="/">
          <div className="brand-label overflow-hidden p-2 d-flex">
            <img src={logo} className="top-nav-logo" alt="Hourglass logo" />
          </div>
        </Link>
        {showSmpwMenu && <SMPWDropdown includeCongLinks={!!ctx.globals.cong} />}

        {hasAttendance && (
          <Nav.Link as={Link} to="/attendance">
            {t("nav.congregation.attendance")}
          </Nav.Link>
        )}

        {HourglassGlobals.hasInfoBoard && (
          <Link to="/infoboard" className="ms-auto">
            <Button variant="secondary">{t("general.information-board")}</Button>
          </Link>
        )}

        <NavLoggedInUser />
      </Nav>
      <HaveSMPWInvite />
    </>
  );
}
